import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

///ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  DatePicker,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  InputNumber,
  Button,
  Divider,
} from "antd";
import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TopContent from "../../../../components/layouts/TopContent";
import TextArea from "antd/lib/input/TextArea";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import definedApi from "../../../../services/definedApi";
import { labelConfig, staticConfig, apiConfig } from "../../customer.config";
import styles from "../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const EditCallDepositAccount = (props) => {
  //DECLARED VARIABLES
  const {
    userData,
    onSelectItemAction,
    rightBtn,
    rightAction,
    getGlListAction,
  } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  // const [form] = Form.useForm();
  // const isActive = Form.useWatch("active", useForm);
  const idType = Form.useWatch("idTypeId", useForm);
  // const openCasa = Form.useWatch("openCasa", useForm);
  const legalOption = Form.useWatch("legalFormId", useForm);

  const dispatch = useDispatch();

  const [officeData, setOfficeData] = useState([]);
  const [legalFormData, setLegalFormData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [titleData, setTitleData] = useState([]);
  const [savingsProduct, setSavingsProduct] = useState([]);
  const [activationDate, setActivationDate] = useState([]);
  const [clientClassificationData, setClientClassificationData] = useState([]);
  const [
    clientNonPersonConstitutionOptions,
    setClientNonPersonConstitutionOptions,
  ] = useState([]);
  const [
    clientNonPersonMainBusinessLineOptions,
    setClientNonPersonMainBusinessLineOptions,
  ] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [identifactionTypeData, setIdentificattionTypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
    setIsLoading(false);
    // getTemplate();
    // getDetailById();
  }, []);

  function getTemplate() {
    setIsLoading(false);

    //   const url = `${apiConfig.Clients}/${state.id}?staffInSelectedOfficeOnly=true&template=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // console.log(objDetail);

        useForm.setFieldsValue({
          legalFormId: objDetail.legalForm.id,
          officeId: objDetail.officeId,
          fullname: objDetail.displayName,
          firstname: objDetail.firstname,
          lastname: objDetail.lastname,
          emailAddress: objDetail.emailAddress,
          mobileNo: objDetail.mobileNo,
          constitutionId: objDetail.clientNonPersonDetails.constitution.id,
          mainBusinessLineId:
            objDetail.clientNonPersonDetails.mainBusinessLine.id,
          accountNo: objDetail.accountNo,
          active: objDetail.active,
          isStaff: objDetail.isStaff,
          riskRating: objDetail.riskRating,
          pepStatus: objDetail.pepStatus,
          // dateOfBirth: BOM.DateTime(objDetail.dateOfBirth, "only date"),
          // dateOfBirth: BOM.FormatArrayDate(activationDate),
          // activationDate: objDetail.timeline.activationDate,
          // submittedOnDate: objDetail.timeline.submittedOnDate,
          // currencyCode: objDetail?.currency?.code,
          // amount: objDetail.amount,
          // active: objDetail?.active,
          // chargeTimeType: objDetail?.chargeTimeType?.id,
          // chargeCalculationType: objDetail?.chargeCalculationType.id,
          // chargePaymentMode: objDetail?.chargePaymentMode.id,
        });

        let tempOfficeData = [];
        let tempLegalFormData = [];
        let tempCustomerType = [];
        let tempTitle = [];
        let tempCountries = [];
        let tempCountryId = [];
        let tempAddressTypeId = [];
        let tempStateProvinceId = [];
        let tempGender = [];
        let tempIdentification = [];
        let tempClientClassification = [];
        let tempClientNonPersonConstitutionOptions = [];
        let tempClientNonPersonMainBusinessLineOptions = [];
        let tempStaffData = [];
        let tempSavingsProduct = [];

        objDetail?.officeOptions?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.clientLegalFormOptions?.forEach((element) => {
          tempLegalFormData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.clientTypeOptions?.forEach((element) => {
          tempCustomerType.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.genderOptions?.forEach((element) => {
          tempGender.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.countryOptions?.forEach((element) => {
          tempCountries.push({
            value: element.description,
            label: element.name,
          });
        });

        objDetail?.clientClassificationOptions?.forEach((element) => {
          tempClientClassification.push({
            value: element.id,
            label: element.name,
          });
        });
        objDetail?.clientNonPersonConstitutionOptions?.forEach((element) => {
          tempClientNonPersonConstitutionOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.clientNonPersonMainBusinessLineOptions?.forEach(
          (element) => {
            tempClientNonPersonMainBusinessLineOptions.push({
              value: element.id,
              label: element.name,
            });
          },
        );

        objDetail?.staffOptions?.forEach((element) => {
          tempStaffData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objDetail?.savingProductOptions?.forEach((element) => {
          tempSavingsProduct.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.idTypes?.forEach((element) => {
          tempIdentification.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);
        setLegalFormData(tempLegalFormData);
        setCustomerTypeData(tempCustomerType);
        setTitleData(tempTitle);
        setSavingsProduct(tempSavingsProduct);
        setActivationDate(objDetail?.activationDate);
        setClientClassificationData(tempClientClassification);
        setClientNonPersonConstitutionOptions(
          tempClientNonPersonConstitutionOptions,
        );
        setClientNonPersonMainBusinessLineOptions(
          tempClientNonPersonMainBusinessLineOptions,
        );
        setStaffData(tempStaffData);
        setCountryData(tempCountries);
        setCountryIdData(tempCountryId);
        setAddressTypeIdData(tempAddressTypeId);
        setStateProvinceIdData(tempStateProvinceId);
        setGenderData(tempGender);
        setIdentificattionTypeData(tempIdentification);
        setIsLoading(false);
      }
    });
  }

  function onCancel() {
    navigate("/acc0106", { replace: false });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Clients}/${state.id}`;

    formValues.dateOfBirth = formValues.dateOfBirth
      ? BOM.DateTime(formValues.dateOfBirth, "only-date")
      : formValues.dateOfBirth;
    formValues.activationDate = formValues.activationDate
      ? BOM.DateTime(formValues.activationDate, "only-date")
      : formValues.activationDate;
    formValues.submittedOnDate = formValues.submittedOnDate
      ? BOM.DateTime(formValues.submittedOnDate, "only-date")
      : formValues.submittedOnDate;
    formValues.idIssuingDate = formValues.idIssuingDate
      ? BOM.DateTime(formValues.idIssuingDate, "only-date")
      : formValues.idIssuingDate;
    formValues.passExpDate = formValues.passExpDate
      ? BOM.DateTime(formValues.passExpDate, "only-date")
      : formValues.passExpDate;

    formValues.clientNonPersonDetails = {
      constitutionId: formValues.constitutionId,
      dateFormat: "dd MMMM yyyy",
      incorpNumber: formValues.incorpNumber,
      incorpValidityTillDate: formValues.incorpValidityTillDate
        ? BOM.DateTime(formValues.incorpValidityTillDate, "only-date")
        : formValues.incorpValidityTillDate,
      locale: "en",
      mainBusinessLineId: formValues.mainBusinessLineId,
      remarks: formValues.remarks,
    };

    delete formValues.officeId;
    delete formValues.openCasa;
    delete formValues.constitutionId;
    delete formValues.incorpNumber;
    delete formValues.incorpValidityTillDate;
    delete formValues.mainBusinessLineId;
    delete formValues.remarks;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editCustomerMsg);
          navigate("/detail-call-deposit-account", {
            state: { id: res.clientId, branchId: res.officeId },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate("/sms0100");
          navigate("/detail-call-deposit-account", {
            state: { id: res.clientId, branchId: res.officeId },
          });
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.editCallDepositAccount}
        pageItems={staticConfig.editCallDepositAccountBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.editCallDepositAccDetails}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.datePastDue}
                  name="datePastDue"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.datePastDue),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.datePastDue}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.daysPastDue}
                  name="daysPastDue"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.lastRate}
                  name="lastRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.lastRate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.lastRate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.nonPerforming}
                  name="nonPerforming"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.finInterest}
                  name="finInterest"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.ytdInterest}
                  name="ytdInterest"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.contractReference}
                  name="contractReference"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.suspectedLaundering}
                  name="suspectedLaundering"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dsgInsured}
                  name="dsgInsured"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.fraud} name="fraud">
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dsgUninsured}
                  name="dsgUninsured"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.legallyDisputed}
                  name="legallyDisputed"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.hedgingPortf}
                  name="hedgingPortf"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.undocumentedAcc}
                  name="undocumentedAcc"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.repoReference}
                  name="repoReference"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.structuredDepositAcc}
                  name="structuredDepositAcc"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.universalSourceSys}
                  name={"universalSourceSys"}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select Option"
                    style={{ width: "100%", marginTop: "10px" }}
                    options={staticConfig.universalSourceSysData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.operationalDeposit}
                  name="operationalDeposit"
                >
                  <Checkbox />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0" />
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.universalBranchId}
                  name="universalBranchId"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.accountHolderInd}
                  name="accountHolderInd"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.accountStatusCode}
                  name="accountStatusCode"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.extensionCode}
                  name="extensionCode"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.jurisdiction}
                  name="jurisdiction"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.bankRecovery}
                  name="bankRecovery"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transferableEligbleDep}
                  name="transferableEligbleDep"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.sortCode}
                  name="sortCode"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dormantDate}
                  name="dormantDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.dormantDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.dormantDate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.facilityReference}
                  name="facilityReference"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.debitInterestRate}
                  name="debitInterestRate"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.portfolioType}
                  name="portfolioType"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.ifrsPortfolioType}
                  name="ifrsPortfolioType"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.rateSpread}
                  name="rateSpread"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dateOfPerformance}
                  name="dateOfPerformance"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.dateOfPerformance),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.dateOfPerformance}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.performingStatus}
                  name={"performingStatus"}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select Option"
                    style={{ width: "100%", marginTop: "10px" }}
                    options={staticConfig.performingStatusData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.symmetricalInflow}
                  name="symmetricalInflow"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.lastIntrstCapDate}
                  name="lastIntrstCapDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.lastIntrstCapDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.lastIntrstCapDate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.universalHqla}
                  name={"universalHqla"}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select Option"
                    style={{ width: "100%", marginTop: "10px" }}
                    options={staticConfig.universalHqlaData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.clientMoneyPlaced}
                  name="clientMoneyPlaced"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.typeOfBusinessActivity}
                  name="typeOfBusinessActivity"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.institutionWhereClient}
                  name="institutionWhereClient"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.typeOfClientAccForCass}
                  name={"typeOfClientAccForCass"}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select Option"
                    style={{ width: "100%", marginTop: "10px" }}
                    options={staticConfig.typeOfClientAccForCassData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.clientAccAckLetter}
                  name="clientAccAckLetter"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.linkedToPeriodicRfRate}
                  name="linkedToPeriodicRfRate"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.universalAccumImpAmnt}
                  name="universalAccumImpAmnt"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.universalGlMarker}
                  name="universalGlMarker"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.beneficiary} name="beneficiary">
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.purposeType}
                  name="purposeType"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.irregularSchedule}
                  name="irregularSchedule"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.ldStartDate}
                  name="ldStartDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.ldStartDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.ldStartDate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.nextRollOverDate}
                  name="nextRollOverDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.nextRollOverDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.nextRollOverDate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.ldMaturityDate}
                  name="ldMaturityDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.ldMaturityDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.ldMaturityDate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.lastRollOverDate}
                  name="lastRollOverDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.lastRollOverDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.lastRollOverDate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.repaymentType}
                  name="repaymentType"
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select Option"
                    style={{ width: "100%", marginTop: "10px" }}
                    options={staticConfig.repaymentTypeData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.originalTerm}
                  name="originalTerm"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.remainingTerm}
                  name="remainingTerm"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.assessmentType}
                  name="assessmentType"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestMargin}
                  name="interestMargin"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.loanPurchased}
                  name="loanPurchased"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.rollOverIndicator}
                  name="rollOverIndicator"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.additionalStricter}
                  name="additionalStricter"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.formalArrangmentSf}
                  name="formalArrangmentSf"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.encumberedAssetFlag}
                  name="encumberedAssetFlag"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.coveredByDgs} name="coveredByDgs">
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.encumberedAmount}
                  name="encumberedAmount"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.temporarySwitchToInt}
                  name="temporarySwitchToInt"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.paymentsSuspended}
                  name="paymentsSuspended"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.reducedPayment}
                  name="reducedPayment"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.termExtension}
                  name="termExtension"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.otherForBearance}
                  name="otherForBearance"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.nonPerfBfForBearance}
                  name="nonPerfBfForBearance"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.centralBankEligibleFlag}
                  name="centralBankEligibleFlag"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dateOfFormalArrang}
                  name="dateOfFormalArrang"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.dateOfFormalArrang),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.dateOfFormalArrang}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dateOfInterestOnlySwitch}
                  name="datePastDue"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.datePastDue),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.datePastDue}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dateOfTermExtension}
                  name="dateOfTermExtension"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.dateOfTermExtension),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.dateOfTermExtension}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dateOfOtherForBearance}
                  name="dateOfOtherForBearance"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.dateOfOtherForBearance,
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.dateOfOtherForBearance}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dateLitigationAction}
                  name="dateLitigationAction"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.dateLitigationAction,
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.dateLitigationAction}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.loanToValue}
                  name="loanToValue"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.universalIntOnMaturity}
                  name="universalIntOnMaturity"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.coverPoolID}
                  name="coverPoolID"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.nettingFlag}
                  name="nettingFlag"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.impairmentStartDate}
                  name="impairmentStartDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.impairmentStartDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.impairmentStartDate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestReversionDate}
                  name="interestReversionDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.interestReversionDate,
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={labelConfig.interestReversionDate}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.loanCollateralPoolRf}
                  name="loanCollateralPoolRf"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.applicationReference}
                  name="applicationReference"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.localCurrencyCode}
                  name="localCurrencyCode"
                >
                  <Input
                    disabled
                    placeholder={labelConfig.gbp}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.accBalanceLocalCurrency}
                  name="accBalanceLocalCurrency"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    id="quantity"
                    value="1"
                    style={{ width: "100%" }}
                    appearance="spin-button"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditCallDepositAccount);
